import React from "react";
import { dateLabel, followUpEnded } from "./api";

/** Uses the recorded allowance; older reviews do not have tracked rounds. */
export default function FollowUpSummary({ review: r }: { review: any }) {
  if (
    r.status !== "completed" ||
    r.closed_at ||
    r.clarification_round_limit == null
  )
    return null;
  const remaining = Math.max(
    0,
    r.clarification_round_limit - r.clarification_rounds_used
  );
  const openRound =
    Number(r.latest_client_seq) > Number(r.attorney_replied_through);
  const ended = followUpEnded(r);
  return (
    <aside className="review-follow-up" aria-label="Included follow-up">
      <strong>
        {ended
          ? "Follow-up window ended"
          : openRound
            ? "Clarification round awaiting your reply"
            : remaining === 0
              ? "No clarification rounds remaining"
              : `${remaining} clarification ${remaining === 1 ? "round" : "rounds"} remaining`}
      </strong>
      <span>
        {r.clarification_rounds_used} of {r.clarification_round_limit} rounds
        used
        {r.clarification_deadline
          ? ` · ${ended ? "Ended" : "Open until"} ${dateLabel(r.clarification_deadline)}`
          : ""}
      </span>
      <details>
        <summary>How clarification rounds work</summary>
        <p>
          A round starts when the client sends a follow-up and includes their
          messages until you reply or choose “No reply needed.” Further
          follow-up needs another available round within the agreed window.
        </p>
      </details>
    </aside>
  );
}
